import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';
import { Layout } from '@/utils/routerHelper';
import { useI18n } from '@/hooks/web/useI18n';

const { t } = useI18n();

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/home',
    redirect: '/index',
    component: Layout,
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/Home/Home.vue'),
        meta: {
          title: '欢迎页',
          noTagsView: false
        }
      }
    ],
    name: 'Home',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
];

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    name: 'highway',
    path: '/highway',
    component: Layout,
    redirect: '/highway/projectManagement',
    meta: {
      title: '公路巡查',
      icon: 'carbon:skill-level-advanced'
    },
    children: [
      {
        path: 'projectManagement',
        name: 'projectManagement',
        component: () => import('@/views/Highway/projectManagement/index.vue'),
        meta: {
          title: '项目管理',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'projectEdit',
        component: () => import('@/views/Highway/ProjectEdit/index.vue'),
        name: 'projectEdit',
        meta: {
          title: '编辑项目',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/highway/projectManagement'
        }
      },
      {
        path: 'questionEdit',
        component: () => import('@/views/Highway/QuestionEdit/index.vue'),
        name: 'questionEdit',
        meta: {
          title: '编辑问题类别',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/highway/projectManagement'
        }
      },
      {
        path: 'InspectionLedger',
        name: 'InspectionLedger',
        component: () => import('@/views/Highway/InspectionLedger/index.vue'),
        meta: {
          title: '巡检台账',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'InspectionEdit',
        component: () => import('@/views/Highway/InspectionEdit/index.vue'),
        name: 'InspectionEdit',
        meta: {
          title: '巡检详情',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/highway/InspectionLedger'
        }
      },
      {
        path: 'Statistics',
        name: 'Statistics',
        component: () => import('@/views/Highway/Statistics/index.vue'),
        meta: {
          title: '巡检统计',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'SummaryGraph',
        name: 'SummaryGraph',
        component: () => import('@/views/Highway/SummaryGraph/index.vue'),
        meta: {
          title: '巡检统计图',
          icon: 'carbon:skill-level-advanced'
        }
      }
    ]
  },
  {
    path: '/subway',
    name: 'subway',
    component: Layout,
    redirect: '/subway/section',
    meta: {
      title: '地铁巡查',
      icon: 'carbon:skill-level-advanced'
    },
    children: [
      {
        path: 'section',
        name: 'section',
        component: () => import('@/views/Subway/Section/index.vue'),
        meta: {
          title: '区间管理',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'sectionEdit',
        name: 'sectionEdit',
        component: () => import('@/views/Subway/SectionEdit/index.vue'),
        meta: {
          title: '编辑区间',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/subway/section'
        }
      },
      {
        path: 'focusItemEdit',
        name: 'focusItemEdit',
        component: () => import('@/views/Subway/FocusItemEdit/index.vue'),
        meta: {
          title: '编辑项目',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/subway/section'
        }
      },
      {
        path: 'ledger',
        name: 'ledger',
        component: () => import('@/views/Subway/InspectionLedger/index.vue'),
        meta: {
          title: '巡检台账',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'ledgerEdit',
        name: 'ledgerEdit',
        component: () => import('@/views/Subway/InspectionEdit/index.vue'),
        meta: {
          title: '巡检详情',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/subway/ledger'
        }
      },
      {
        path: 'focusLedgerEdit',
        name: 'focusLedgerEdit',
        component: () => import('@/views/Subway/FocusLedgerEdit/index.vue'),
        meta: {
          title: '巡检详情',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/subway/ledger'
        }
      }
    ]
  },
  {
    path: '/epc',
    name: 'epc',
    component: Layout,
    redirect: '/epc/list',
    meta: {
      title: 'EPC总包',
      icon: 'carbon:skill-level-advanced',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/Epc/List/index.vue'),
        meta: {
          title: '项目列表',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'edit',
        name: 'edit',
        component: () => import('@/views/Epc/Edit/index.vue'),
        meta: {
          title: '编辑项目',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/epc/list'
        }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_PATH),
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
});

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'Home', 'NoFind', 'Root'];
  router.getRoutes().forEach((route) => {
    const { name } = route;
    console.log(name);
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
};

export const setupRouter = (app: App<Element>) => {
  app.use(router);
};

export default router;
